<template>

  <div>
    <div class="card cr-card" style="margin:0px 30px 30px 30px;">
      <div class="card-body">
        <h5 class="card-title">{{sectionTitle}}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{sectionSubtitle}}</h6>
        <div class="table-responsive-xxl">
          <table class="cr-resume-table table table-striped table-hover">
            <thead>
            <tr>
              <th class="cr-resume-background-none cr-resume-border-bottom-none cr-resume-border-right">&nbsp;</th>
              <th colspan="3" class="cr-resume-border-top cr-resume-border-right fs-5 text-center">As Captain</th>
              <th colspan="3" class="cr-resume-border-top cr-resume-border-right fs-5 text-center">As Crew</th>
              <th colspan="3" class="cr-resume-border-top cr-resume-border-right fs-5 text-center">Total</th>
            </tr>
            <tr>
              <th class="cr-resume-background-none cr-resume-border-top-none cr-resume-border-right">&nbsp;</th>
              <th class="text-center text-nowrap">Less than<br>8.5m (28 ft)</th>
              <th class="text-center text-nowrap">8.5m (28 ft)<br>- 12m (39 ft)</th>
              <th class="text-center text-nowrap cr-resume-border-right">Greater than<br>12m (39 ft)</th>
              <th class="text-center text-nowrap">Less than<br>8.5m (28 ft)</th>
              <th class="text-center text-nowrap">8.5m (28 ft)<br>- 12m (39 ft)</th>
              <th class="text-center text-nowrap cr-resume-border-right">Greater than<br>12m (39 ft)</th>
              <th class="text-center text-nowrap">Less than<br>8.5m (28 ft)</th>
              <th class="text-center text-nowrap">8.5m (28 ft)<br>- 12m (39 ft)</th>
              <th class="text-center text-nowrap cr-resume-border-right">Greater than<br>12m (39 ft)</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-nowrap cr-resume-border-right">Inland/Lake</td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.inlandLake.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.inlandLake.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.captain.inlandLake.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.inlandLake.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.inlandLake.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.crew.inlandLake.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.inlandLake.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.inlandLake.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.total.inlandLake.large)"></td>
            </tr>
            <tr>
              <td class="text-nowrap cr-resume-border-right">Great Lakes</td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.greatLakes.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.greatLakes.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.captain.greatLakes.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.greatLakes.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.greatLakes.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.crew.greatLakes.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.greatLakes.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.greatLakes.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.total.greatLakes.large)"></td>
            </tr>
            <tr>
              <td class="text-nowrap cr-resume-border-right">Near Coastal</td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.nearCoastal.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.nearCoastal.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.captain.nearCoastal.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.nearCoastal.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.nearCoastal.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.crew.nearCoastal.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.nearCoastal.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.nearCoastal.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.total.nearCoastal.large)"></td>
            </tr>
            <tr>
              <td class="text-nowrap cr-resume-border-right">Offshore</td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.offshore.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.offshore.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.captain.offshore.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.offshore.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.offshore.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.crew.offshore.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.offshore.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.offshore.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.total.offshore.large)"></td>
            </tr>
            <tr>
              <td class="text-nowrap cr-resume-border-right">Canal</td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.canal.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.canal.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.captain.canal.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.canal.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.canal.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.crew.canal.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.canal.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.canal.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.total.canal.large)"></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="cr-resume-footer-note">A | B% - this is logged days (at least four hours) experience with the percentage of entries that have been verified by either a crewmate on the vessel at the time or directly with the charter company via Charter Rode. The n-m below each logged experience represents how many entries have been verified by crewmate (n) or charter company (m) digital verification. Charter company verification is the highest trusted verification. Crewmate digital verification is considered to be very reliable. Self verification may need to be verified directly with the sailor.</div>
      </div>
    </div>
  </div>

</template>
<script>

export default {
  name: 'ResumeSectionLocationTypeView',
  props: {
    'sectionTitle': String,
    'sectionSubtitle':  String,
    'sectionData': Object
  },
  methods: {
    formatResumeDaysCell(aCell) {
      if ( aCell.days > 0 ) {
        return '<div>'+aCell.days+'<span style="position:relative;top:-1px;font-size: 10px;color:#888;"> | '+aCell.verified.percent+'</span></div><div style="font-size: 10px;color:#888;">'+aCell.verified.crewmate+'-'+aCell.verified.charterCompany+'</div>'
      } else {
        return '--'
      }
    }
  }
}
</script>

<style>
.cr-resume-table {
  font-size:12px;
  width: 100%;
}

.cr-resume-table th {
  background: #f6f6f6;
}

.cr-resume-background-none {
  background: transparent!important;
}

.cr-resume-border-top {
  border-top: 1px solid #ccc;
}
.cr-resume-border-right {
  border-right: 1px solid #ccc;
}

.cr-resume-border-top-none {
  border-top:none!important;
}
.cr-resume-border-bottom-none {
  border-bottom:none!important;
}

.cr-resume-footer-note {
  font-size: 11px;
  color:#999;
}
</style>